import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CollapseCard from '../../shared/components/CollapseCard';

export default class OutsourceInfoCard extends React.Component {

    render() {
        const currentPathname = window.document.location.pathname;
        const isMyContractorsPath = currentPathname.includes('mis-contratistas');

        if ( isMyContractorsPath ) {
            return null;
        }

        const {
            nif,
            ccc,
            name,
            phone,
            email,
            address,
            disabled,
            contact_person,
            document_schema,
            document_schema_monthly,
        } = this.props.outsource;

        const title = nif + ' - ' + name;

        return (
            <CollapseCard
                title={title}
                collapsed={false}
            >
                <div className="info-card-content">
                    <div>
                        <b>{I18nUtils.tr('TR_PERSONA_DE_CONTACTO')}: </b>
                        <span>{contact_person || '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_TELEFONO')}: </b>
                        <span>{phone || '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_EMAIL')}: </b>
                        <span>{email || '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_DIRECCION')}: </b>
                        <span>{address || '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_CODIGO_CUENTA_COTIZACION_CCC')}: </b>
                        <span>{ccc || '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_ESQUEMA_DE_DOCUMENTOS')}: </b>
                        <span>{document_schema ? document_schema.name : '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_ESQUEMA_DE_DOCUMENTOS_MENSUAL')}: </b>
                        <span>{document_schema_monthly ? document_schema_monthly.name : '-'}</span>
                    </div>
                    <div>
                        <b>{I18nUtils.tr('TR_ESTADO')}: </b>
                        <span>{I18nUtils.tr(disabled ? 'TR_INACTIVA' : 'TR_ACTIVA')}</span>
                    </div>
                </div>
            </CollapseCard>
        );
    }
}

OutsourceInfoCard.propTypes = {
    outsource: PropTypes.any,
};

OutsourceInfoCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceInfoCard.js